var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 508,
    viewBox: "0 0 367 508",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.991 251.817C506.798 111.542 392.115 -1.19618 251.84 0.00958245C111.565 1.21534 -1.18366 115.908 0.00938132 256.183C1.20242 396.458 115.885 509.196 256.16 507.99C396.435 506.785 509.184 392.092 507.991 251.817ZM387.204 251.372C386.562 175.869 325.158 115.185 250.055 115.83C174.951 116.476 114.588 178.207 115.23 253.71C115.873 329.212 177.277 389.896 252.38 389.251C327.484 388.605 387.846 326.875 387.204 251.372Z",
    fill: "#FF6000",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBg);
export default __webpack_public_path__ + "static/media/menuBg.6612a68c653e182cde38181e80321ae5.svg";
export { ForwardRef as ReactComponent };